"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttrDTO = void 0;
const any_js_1 = require("./any.js");
const anyOf_js_1 = require("./anyOf.js");
const list_js_1 = require("./list.js");
const map_js_1 = require("./map.js");
const primitive_js_1 = require("./primitive.js");
const record_js_1 = require("./record.js");
const set_js_1 = require("./set.js");
const getAttrDTO = (attr) => {
    /**
     * @debt feature "handle defaults, links & validators"
     */
    switch (attr.type) {
        case 'any':
            return (0, any_js_1.getAnyAttrDTO)(attr);
        case 'null':
        case 'boolean':
        case 'number':
        case 'string':
        case 'binary':
            return (0, primitive_js_1.getPrimitiveAttrDTO)(attr);
        case 'set':
            return (0, set_js_1.getSetAttrDTO)(attr);
        case 'list':
            return (0, list_js_1.getListAttrDTO)(attr);
        case 'map':
            return (0, map_js_1.getMapAttrDTO)(attr);
        case 'record':
            return (0, record_js_1.getRecordAttrDTO)(attr);
        case 'anyOf':
            return (0, anyOf_js_1.getAnyOfAttrDTO)(attr);
    }
};
exports.getAttrDTO = getAttrDTO;
